import React from "react";
import moment from "moment";
import { Radio, Checkbox } from "antd";

import { DATETIME_FORMAT_FRONTEND } from "../../constants";
import TableBase from "./Base";
import { getTranslation } from "../../utils/helper";

const ContactsTable = ({
  scrollHeight,
  actionWidth,
  withAction,
  setting,
  selectContact = false,
  mutiSelectContact = false,
  selectedContact,
  selectedContacts = [],
  handleSelectContact,
  isSortLocal = false,
  ...props
}) => {
  const selectedContactsIds = selectedContacts.map(c => c._id);
  const COLUMNS = [
    {
      title: getTranslation(setting, "Contacts", "Name"),
      dataIndex: "name",
      width: 200,
      ellipsis: true,
      fixed: true,
      render(name, record) {
        return (
          <div className="ContactLocationName">
            {selectContact && (
              <>
                {mutiSelectContact ? (
                  <Checkbox
                    checked={selectedContactsIds.includes(record._id)}
                    onClick={() => handleSelectContact(record)}
                    style={{ marginRight: "8px" }}
                  />
                ) : (
                  <Radio checked={record._id === selectedContact?._id} onClick={() => handleSelectContact(record)} />
                )}
              </>
            )}
            {name}
          </div>
        );
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: getTranslation(setting, "Contacts", "Phone Number"),
      dataIndex: "phone",
      width: 200,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Contacts", "Address"),
      dataIndex: "address",
      width: 350,
      ellipsis: true,
      render(address) {
        return <span title={address}>{address}</span>;
      },
    },
    {
      title: getTranslation(setting, "Contacts", "Time Window"),
      dataIndex: "timeWindow",
      width: 150,
      ellipsis: true,
      render(_shift, record) {
        return (
          <span>
            {record.startTime} - {record.endTime}
          </span>
        );
      },
    },
    {
      title: getTranslation(setting, "Contacts", "Types"),
      dataIndex: "types",
      width: 200,
      ellipsis: true,
      render(value) {
        return value.join(", ");
      },
    },
    {
      title: getTranslation(setting, "Contacts", "Load"),
      dataIndex: "load",
      width: 100,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Contacts", "Duration"),
      dataIndex: "duration",
      width: 100,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Contacts", "Updated At"),
      dataIndex: "updatedAt",
      width: 250,
      render(value) {
        return value ? moment(value).format(DATETIME_FORMAT_FRONTEND) : "-";
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return (
      <TableBase
        columns={COLUMNS}
        scroll={{ x: 991, y: scrollHeight }}
        isKeepOldSelect={true}
        isSortLocal={isSortLocal}
        {...props}
      />
    );
  } else {
    return (
      <TableBase isKeepOldSelect={true} columns={COLUMNS} scroll={{ x: 991 }} isSortLocal={isSortLocal} {...props} />
    );
  }
};

export default ContactsTable;
